import memoizeOne from 'memoize-one';
import { token } from '@atlaskit/tokens';
import messages from './messages.tsx';

export type FormattingColor = {
	label: { id: string; defaultMessage: string; description: string };
	value: string;
	hoverValue: string;
};

export const formattingColors: Record<string, FormattingColor> = {
	lightPurple: {
		label: messages.lightPurple,
		value: token('color.background.accent.purple.subtlest'),
		hoverValue: token('color.background.accent.purple.subtlest.hovered'),
	},
	lightBlue: {
		label: messages.lightBlue,
		value: token('color.background.accent.blue.subtlest'),
		hoverValue: token('color.background.accent.blue.subtlest.hovered'),
	},
	lightGreen: {
		label: messages.lightGreen,
		value: token('color.background.accent.green.subtlest'),
		hoverValue: token('color.background.accent.green.subtlest.hovered'),
	},
	lightTeal: {
		label: messages.lightTeal,
		value: token('color.background.accent.teal.subtlest'),
		hoverValue: token('color.background.accent.teal.subtlest.hovered'),
	},
	lightYellow: {
		label: messages.lightYellow,
		value: token('color.background.accent.yellow.subtlest'),
		hoverValue: token('color.background.accent.yellow.subtlest.hovered'),
	},
	lightRed: {
		label: messages.lightRed,
		value: token('color.background.accent.red.subtlest'),
		hoverValue: token('color.background.accent.red.subtlest.hovered'),
	},
	lightGray: {
		label: messages.lightGray,
		value: token('color.background.accent.gray.subtlest'),
		hoverValue: token('color.background.accent.gray.subtlest.hovered'),
	},
	purple: {
		label: messages.purple,
		value: token('color.background.accent.purple.subtler'),
		hoverValue: token('color.background.accent.purple.subtler.hovered'),
	},
	blue: {
		label: messages.blue,
		value: token('color.background.accent.blue.subtler'),
		hoverValue: token('color.background.accent.blue.subtler.hovered'),
	},
	green: {
		label: messages.green,
		value: token('color.background.accent.green.subtler'),
		hoverValue: token('color.background.accent.green.subtler.hovered'),
	},
	teal: {
		label: messages.teal,
		value: token('color.background.accent.teal.subtler'),
		hoverValue: token('color.background.accent.teal.subtler.hovered'),
	},
	yellow: {
		label: messages.yellow,
		value: token('color.background.accent.yellow.subtler'),
		hoverValue: token('color.background.accent.yellow.subtler.hovered'),
	},
	red: {
		label: messages.red,
		value: token('color.background.accent.red.subtler'),
		hoverValue: token('color.background.accent.red.subtler.hovered'),
	},
	gray: {
		label: messages.gray,
		value: token('color.background.accent.gray.subtler'),
		hoverValue: token('color.background.accent.gray.subtler.hovered'),
	},
};

// Extract the CSS variable name from var(--variable-name) or var(--variable-name, fallback)
export const extractVariableName = (cssValue: string) => {
	const match = cssValue.match(/var\((--[^,)]+)/);
	return match ? match[1] : cssValue;
};

export const getColorKeyFromValue = memoizeOne((value: string) => {
	const inputVariableName = extractVariableName(value);

	const selectedColor = Object.entries(formattingColors).find(
		([_, color]) => extractVariableName(color.value) === inputVariableName,
	);

	return selectedColor?.[0];
});
